import { 
    apiInsertContract,
    apiInsertContractIdImg,
    apiInsertContractFile,
    apiNotifyTanant,
    apiBizGetContractPeriod
} from "@/apis/api.js"; 
import { 
    getAvailableHouse
} from "@/apis/landlord/newPaperContract.js"; 
import router from '@/router'
const defaultContractData = {
    "tenantName" : null,
    "tenantPhone" : null,
    "tenantIdNumber" : null,
    "contractBeginTime" : null,
    "contractEndTime" : null,
    "tenantNumber" : null,
}
const defaultIdentification = {
    font: [],
    back: []
}
const defaultDatePeriod = {
    contractPeriod: [],
}
const defaultSelectedHouseInfo = {
    seleted: null,
    houseCid: null,
    houseName: null,
    rent: 0,
    address: null,
    houseStatus: null,
    moveInDate: null,
    contractPeriod: [],
    agentName: null
}
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_contract_id: 'newContract/set_contract_id',
    set_contract: 'newContract/set_contract',
    set_contract_id_img: 'newContract/set_contract_id_img',
    set_contract_paper: 'newContract/set_contract_paper',
    set_contract_paper_type: 'newContract/set_contract_paper_type',
    set_contract_status: 'newContract/set_contract_status',
    set_upload_status: 'newContract/set_upload_status',
    set_notify_status: 'newContract/set_notify_status',
    set_available_house: 'newContract/set_available_house',
    set_default: 'newContract/set_default',
    set_contract_period: 'newContract/set_contract_period',
    set_selected_house: 'newContract/set_selected_house',
    set_contract_data: 'bizNewContract/set_contract_data',
    set_id_card_img: 'bizNewContract/set_id_card_img',
    set_date_period: 'bizNewContract/set_date_period',
}

// count state 必須是 Object
const state = {
    contractId: null,
    contractStatus: 1,
    contractPaperType: null,
    contract: [],
    contractIdImg: [],
    contractPaper: [],
    availableHouseList: [],
    selectedHouseInfo: Object.assign({}, defaultSelectedHouseInfo),
    contractData: Object.assign({}, defaultContractData),
    identification: Object.assign({}, defaultIdentification),
    datePeriod: Object.assign({}, defaultDatePeriod),
    contractPeriod: [],
    uploadStatus: {
        status: false,
        msg: null,
    },
    notifyStatus: {
        status: false,
        msg: null,
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_CONTRACT_STATUS: (state) => {
        return state.contractStatus
    },
    GET_UPLOAD_STATUS: (state) => {
        return state.uploadStatus
    },
    GET_NOTIFY_STATUS: (state) => {
        return state.notifyStatus
    },
    GET_NEW_CONTRACT_DATA: (state) => {
        return state.contractData
    },
    GET_NEW_CONTRACT_IDENTIFICATION: (state) => {
        return state.identification
    },
    GET_NEW_CONTRACT_DATE_PERIOD: (state) => {
        return state.datePeriod
    },
    GET_NEW_CONTRACT_SELECTED_HOUSE: (state) => {
        return state.selectedHouseInfo
    },
    GET_NEW_CONTRACT_AVAILABLE_HOUSE: (state) => {
        return state.availableHouseList
    },
    GET_NEW_CONTRACT_PERIOD: (state) => {
        return state.contractPeriod
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    setNewContractId ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_id, data);
            resolve()
        })
    },
    setNewContract ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract, data);
            resolve()
        })
    },
    setNewContractIdImg ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_id_img, data);
            resolve()
        })
    },
    setNewContractPaper ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_paper, data);
            resolve()
        })
    },
    setNewContractPaperType ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_contract_paper_type, data);
            resolve()
        })
    },
    getNewContractAvailableHouse ( {commit} ) {
        return new Promise((resolve, reject) => {
            getAvailableHouse()
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_available_house, res.data.result)
                }
                resolve()
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    getGetContractPeriod ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetContractPeriod(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    console.log('getGetContractPeriod',res.data.result)
                    commit(types.set_contract_period, res.data.result);
                    
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setNewContractSelectedHouse ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_selected_house, data)
        })
    },
    saveNewContract ( {commit, dispatch, state} , action) {
        return new Promise((resolve, reject) => {
            dispatch('setLoadingState', 1)
            // state.contract.dash = parseInt(state.contract.dash)
            let data = state.contract
            apiInsertContract(data)
            .then(res => {
                console.log(res)
                // console.log(state.contractIdImg)
                console.log('儲存合約基本資料')
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_contract_id, res.data.result.paperContractCid)
                    // console.log('success')
                    // console.log(state.contractIdImg)
                    if(state.contractIdImg.back && state.contractIdImg.font && state.contractIdImg.back.length > 0 && state.contractIdImg.font.length > 0){
                        console.log('有身分證檔案')
                        dispatch('saveNewContractIdImg').then( () => {
                            console.log('打上傳身分證ＡＰＩ')
                            if( action == 1){
                                
                                dispatch('saveNewContratFile', 1)
                                // router.push('/landlord/leasemanagement/home?success=1')
                                // window.location.href = '/landlord/leasemanagement/home?success=1'
                                // dispatch('setLoadingState', 0)
                                resolve()
                            }else{
                                dispatch('saveNewContratFile', 0)
                                // dispatch('setLoadingState', 0)
                                // commit(types.set_contract_status, 3)
                                resolve()
                            }
                        })
                    }else{
                        if( action == 1){
                            // router.push('/landlord/leasemanagement/home?success=1#紙本確認中')
                            // window.location.href = '/landlord/leasemanagement/home?success=1'
                            dispatch('saveNewContratFile', 1)
                            // dispatch('setLoadingState', 0)
                            resolve()
                        }else{
                            dispatch('saveNewContratFile', 0)
                            // dispatch('setLoadingState', 0)
                            // commit(types.set_contract_status, 2)
                            resolve()
                        }
                    }
                    
                }else{
                    commit(types.set_contract_status, 1)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    dispatch('setLoadingState', 0)

                }
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                reject(err)
            })
        })
    },
    saveNewContractIdImg ( {commit, state} ) {
        return new Promise((resolve, reject) => {
            console.log(state.contractId)
            console.log(state.contractIdImg.font[0].file)
            console.log(state.contractIdImg.back[0].file)
            let formData = new FormData();
                formData.append('frontSide', state.contractIdImg.font[0].file);
                formData.append('backSide', state.contractIdImg.back[0].file);
                formData.append('paperContractCid', state.contractId);
            apiInsertContractIdImg(formData)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    commit(types.set_upload_status, {
                        status: true,
                        msg: res.data.errorMsg,
                    })
                    commit(types.set_contract_status, 1)
                    dispatch('setLoadingState', 0)

                }
            })
            .catch(err => {
                commit(types.set_upload_status, {
                    status: true,
                    msg: err,
                })
                reject(err)
            })
        })
    },
    saveNewContratFile ( {commit, state, dispatch}, action ) {
        return new Promise((resolve, reject) => {
            dispatch('setLoadingState', 1)
            if( state.contractPaperType == "pdf" ){
                // console.log(state.contractPaper[state.contractPaper.length-1].file)
                let formData = new FormData();
                    formData.append('document', state.contractPaper[state.contractPaper.length-1].file);
                    formData.append('paperContractCid', state.contractId);
                    formData.append('page', '');
                apiInsertContractFile(formData)
                .then(res => {
                    // console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        if( action == 1){
                            dispatch('setLoadingState', 0)
                                router.push('/landlord/leasemanagement/home#紙本確認中')
                                dispatch('setAlarmStatus', {status: true,title: '新增紙本合約成功',type: 'success',closeBtn: true})
                                // window.location.href = '/landlord/leasemanagement/home?success=1'
                            resolve()
                        }else{
                            dispatch('notifyTanant').then( () => {
                                
                                resolve()
                            })
                        }
                        resolve()
                    }else{
                        commit(types.set_upload_status, {
                            status: true,
                            msg: res.data.errorMsg,
                        })
                        commit(types.set_contract_status, 1)
                        dispatch('setLoadingState', 0)
                    }
                })
                .catch(err => {
                    commit(types.set_upload_status, {
                        status: true,
                        msg: err,
                    })
                    reject(err)
                })
            }else if( state.contractPaperType == "image" ){
                for (let i = 0; i < state.contractPaper.length; i++) {
                    const element = state.contractPaper[i];

                    let formData = new FormData();
                    formData.append('document', element.file);
                    formData.append('paperContractCid', state.contractId.housesTemporaryCid);
                    formData.append('page', i+1);
                    apiInsertContractFile(formData)
                    .then(res => {
                        // console.log(res)
                        if( res.data.status == "SUCCESS" ){
                            if( action == 1){
                                dispatch('setLoadingState', 0)
                                router.push('/landlord/leasemanagement/home#紙本確認中')
                                dispatch('setAlarmStatus', {status: true,title: '新增紙本合約成功',type: 'success',closeBtn: true})
                                // window.location.href = '/landlord/leasemanagement/home?success=1'
                                resolve()
                            }else{
                                dispatch('notifyTanant').then( () => {
                                    commit(types.set_contract_status, 3)
                                    dispatch('setLoadingState', 0)
                                    resolve()
                                })
                            }
                        }else{
                            commit(types.set_upload_status, {
                                status: true,
                                msg: res.data.errorMsg,
                            })
                        }
                    })
                    .catch(err => {
                        commit(types.set_upload_status, {
                            status: true,
                            msg: err,
                        })
                        reject(err)
                    })
                }
            }
            
        })
    },
    notifyTanant ( {commit, state, dispatch} ) {
        return new Promise((resolve, reject) => {
            let data = {
                paperContractCid: state.contractId
            }
            apiNotifyTanant(data)
            .then(res => {
                console.log(res)
                console.log('打通知租客ＡＰＩ')

                if( res.data.status == "SUCCESS" ){
                    commit(types.set_contract_status, 3)
                    dispatch('setLoadingState', 0)
                    commit(types.set_notify_status, {
                        status: true,
                        msg: '通知租客成功',
                    })
                    resolve()
                }else{
                    commit(types.set_contract_status, 1)
                    dispatch('setLoadingState', 0)
                    commit(types.set_upload_status, {
                        status: true,
                        msg: res.data.errorMsg,
                    })
                }
            })
            .catch(err => {
                commit(types.set_upload_status, {
                    status: true,
                    msg: err,
                })
                reject(err)
            })
        })
    },
    setNewContractDefault ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_default)
        })
    }
    
}

// mutations
const mutations = {
    [types.set_contract_id](state, data){
        state.contractId = data
    },
    [types.set_contract](state, data){
        state.contract = data
    },
    [types.set_contract_id_img](state, data){
        state.contractIdImg = data
    },
    [types.set_contract_paper](state, data){
        state.contractPaper = data
    },
    [types.set_contract_paper_type](state, data){
        state.contractPaperType = data
    },
    [types.set_contract_status](state, data){
        state.contractStatus = data
    },
    [types.set_upload_status](state, data){
        state.uploadStatus = data
    },
    [types.set_notify_status](state, data){
        state.notifyStatus = data
    },

    [types.set_contract_data](state, data){
        state.contractData = data
    },
    [types.set_id_card_img](state, data){
        state.identification = data
    },
    [types.set_date_period](state, data){
        state.datePeriod = data
    },
    [types.set_available_house](state, data){
        state.availableHouseList = data
    },
    [types.set_selected_house](state, data){
        state.selectedHouseInfo = data
    },
    [types.set_contract_period](state, data){
        state.contractPeriod = data
    },
    [types.set_default](state, data){
        state.contractStatus = 1
        state.contractData = Object.assign({}, defaultContractData)
        state.identification = Object.assign({}, defaultIdentification)
        state.datePeriod = Object.assign({}, defaultDatePeriod)
        state.selectedHouseInfo = Object.assign({}, defaultSelectedHouseInfo)
    },
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/newContract.js